import { createRoutine } from "redux-saga-routines";

export const getAllUsers$ = createRoutine("GET_ALL_USERS");



// WEBPACK FOOTER //
// ./src/redux/actions/user.js